import { useWorkspaceContext } from '@sales-app/context/workspace/workspace.hooks'
import { WorkspaceTab } from '@sales-app/context/workspace/workspace.type'
import { getWorkspacePath } from '@sales-app/context/workspace/workspace.util'
import { BookablePersonType } from '@sales-app/types/BookablePersonType'
import { formatInTimeZone } from 'date-fns-tz'
import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import { NoResults } from '@/components'

export const DefaultWorkspace = () => {
  const [workspaceState] = useWorkspaceContext()
  const { tabs, recentlyClosedTabs } = workspaceState
  const navigate = useNavigate()
  const openTab = (tab: WorkspaceTab) => {
    const { view, potentialBookingId, bookablePersonId, bookablePersonType } = tab
    const path = getWorkspacePath({
      view: view,
      type: bookablePersonType,
      id: bookablePersonId,
      potentialBookingId,
    })

    navigate(path)
  }

  return (
    <div className="flex w-full flex-col p-4 md:p-8">
      {tabs && tabs.length > 0 && (
        <>
          <div className="mb-2 flex w-full items-center justify-between md:mb-8 md:flex-row">
            <h2 className=" text-header-lg leading-120">Ongoing</h2>
          </div>
          <div className="mb-8 grid w-full grid-flow-row grid-cols-4 gap-x-4 gap-y-4">
            {tabs.map((tab, i) => (
              <TabsCard key={i} openTab={openTab} tab={tab} />
            ))}
          </div>
        </>
      )}
      <div className="mb-2 flex w-full items-center justify-between md:mb-8 md:flex-row">
        <h2 className=" text-header-lg leading-120">Recently closed</h2>
      </div>

      <div className="grid w-full grid-flow-row grid-cols-4 gap-x-4 gap-y-4">
        {recentlyClosedTabs.map((tab, i) => {
          const tabExsistIndex = tabs.findIndex((t) => t.bookablePersonId === tab.bookablePersonId)
          if (tabExsistIndex < 0) {
            return <TabsCard key={i} openTab={openTab} tab={tab} />
          }
        })}
      </div>
      {recentlyClosedTabs.length === 0 && <NoResults />}
    </div>
  )
}

type Props = {
  openTab: (tab: WorkspaceTab) => void
  tab: WorkspaceTab
}

const TabsCard: FC<Props> = ({ tab, openTab }) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const formatedTime = formatInTimeZone(tab.lastAccessedTime, timezone, 'MMM dd,yyyy hh:mm aa')
  return (
    <div
      className="flex w-full cursor-pointer flex-col rounded-lg border bg-grey-100 p-4 border-secondary"
      onClick={() => openTab(tab)}
      role="presentation"
    >
      <p className="mb-2 text-header-sm capitalize">{tab.label}</p>
      <p
        className={`${
          tab.bookablePersonType === BookablePersonType.LEAD ? ' text-semantic-warning' : ' text-semantic-info'
        } text-p-lg`}
      >
        {tab.bookablePersonType}
      </p>
      <p>{formatedTime}</p>
    </div>
  )
}
